// extracted by mini-css-extract-plugin
export var swipeContainer = "f6Rb8";
export var swipeFromLeft = "vfhwj";
export var swipeFromRight = "v9Bm_";
export var swipeIcon = "QkerH";
export var swipeIconFull = "jFHYY";